export default "/images/payment-mc.png?27d8f5ecae3355136b4ecf44dd6187fb";